import * as React from 'react';

import { Modal } from '@cian/ui-kit/prev/modal';

export interface ITooltipProps {
  master: React.ReactElement;
  children: React.ReactNode | React.ReactNode[];
}

export function Tooltip({ children, master }: ITooltipProps) {
  return <Modal master={master}>{children}</Modal>;
}
